// Pill colorato per stato ticket — usa variabili --fc-status-*
import type { TicketStatus } from '@fieldcore/types'
import { cn } from '../../lib/utils'

const STATUS_LABELS: Record<TicketStatus, string> = {
  new: 'Nuovo',
  assigned: 'Assegnato',
  in_progress: 'In lavorazione',
  completed: 'Completato',
  cancelled: 'Annullato',
  escalated: 'Urgente',
}

const STATUS_CLASSES: Record<TicketStatus, string> = {
  new: 'status-new',
  assigned: 'status-assigned',
  in_progress: 'status-in-progress',
  completed: 'status-completed',
  cancelled: 'status-cancelled',
  escalated: 'status-escalated',
}

interface StatusPillProps {
  status: TicketStatus
  className?: string
  size?: 'sm' | 'md'
}

export function StatusPill({ status, className, size = 'md' }: StatusPillProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full font-medium',
        size === 'sm' ? 'px-1.5 py-0.5 text-xs' : 'px-2.5 py-1 text-xs',
        STATUS_CLASSES[status],
        className
      )}
      role="status"
      aria-label={`Stato: ${STATUS_LABELS[status]}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" aria-hidden="true" />
      {STATUS_LABELS[status]}
    </span>
  )
}
